<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_iv"></a><a id="page_v"></a><span class="bold">For J.A.P.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?2c2c36e6